export default {
    _containers        : null,
    _ids               : null,
    _map               : null,
    _products          : null,
    _form              : null,
    _bounds            : null,
    _infoWindow        : null,
    _params            : null,
    _categories        : [],
    _municipalities    : [],
    _mapData           : [],
    _containerAttr     : 'data-product-search-container',
    _mapAttr           : 'data-product-search-map',
    _formAttr          : 'data-product-search-form',
    _btnAttr           : 'data-product-search-toggle',
    _labelAttr         : 'data-product-search-label',
    _action            : '/actions/mm/poi/index',
    _mainMunicipalities: null,
    _mainCategories    : {
        1  : 'overnatting',
        2  : 'servering',
        4  : 'tjenester',
        36 : 'aktiviteter',
        69 : 'attraksjoner',
        99 : 'transport',
        110: 'sted',
        203: 'reisepakke',
        405: 'generelle',
    },
    init() {
        this._containers = document.querySelectorAll(`[${this._containerAttr}]`);
        if (!this._containers) {
            return;
        }

        for (const container of this._containers) {
            this._form = container.querySelector(`[${this._formAttr}]`);
            const map  = container.querySelector(`[${this._mapAttr}]`);
            this._ids  = container.getAttribute(this._containerAttr);

            this._handleParams();
            this._getMapProducts(map);
        }
    },
    reload() {
		this.init();
    },
    async _getMapProducts(container) {
        return new Promise(() => {
            const xhr = new XMLHttpRequest();

            xhr.onload = () => {
                // console.log(xhr.responseText);
                if (xhr.responseText) {
                    const items = JSON.parse(xhr.responseText);
                    this._products = items;

                    // get categories og municipalities dynamically from product list
                    const categories = new Set();
                    const municipalities = new Set();

                    this._products.forEach((p) => {
                        if (p.category.trim()) {
                            categories.add(p.category);
                        }

                        if (p.municipality.trim()) {
                            municipalities.add(p.municipality);
                        }

                        this.categories =  [...categories].sort();
                        this._mainMunicipalities  = [...municipalities].sort();
                    });


                    if (this._mainMunicipalities) {
                        this._addMunicipalitiesFilters();
                    }
                    
                    this._generateMap(container);
                    this._addMarkers();

                    if (this._categories.length) {
                        this._displayMarkers();
                    }

                    this._handleFilters();
                }
            }

            xhr.open('get', this._getActionUrl());
            xhr.send();
        });
    },
    _generateMap(container) {
        const options = {
            zoom             : 9,
            mapTypeControl   : false,
            streetViewControl: false,
            fullscreenControl: false,
            scrollwheel      : false
        }
        this._map    = new google.maps.Map(container, options);
        this._bounds = new google.maps.LatLngBounds();
    },
    _handleParams() {
        this._params = new URLSearchParams(window.location.search);

        const categories = [];
        for (const [key, value] of this._params) {
            if (key.includes('kategori')) {
                categories.push(value);
            } else if (key.includes('kommune')) {
                this._municipalities.push(value);
            }
        }

        for (const id in this._mainCategories) {
            if (categories.includes(this._mainCategories[id])) {
                this._categories.push(parseInt(id));
            }
        }
    },
    _handleFilters() {
        if (this._form) {
            const filters = this._form.querySelectorAll(`[${this._labelAttr}]`);
            Array.prototype.forEach.call(filters, filter => {
                const input = filter.querySelector('input');
                const name  = filter.getAttribute(this._labelAttr);
                const id    = input.value;
                if (name === 'kategori') {
                    input.checked = this._categories.includes(parseInt(id));
                } else if (name === 'kommune') {
                    input.checked = this._municipalities.includes(id);
                }

                filter.addEventListener('click', event => {
                    event.preventDefault();

                    this._params.delete(`${name}[]`);
                    if (name === 'kategori') {
                        const included = this._categories.includes(parseInt(id));
                        if (included) {
                            this._categories.splice(this._categories.indexOf(parseInt(id)), 1);
                        } else {
                            this._categories.push(parseInt(id));
                        }
                        input.checked = !included;

                        for (const id of this._categories) {
                            this._params.append(`${name}[]`, this._mainCategories[id]);
                        }
                    } else if (name === 'kommune') {
                        const included = this._municipalities.includes(id);
                        if (included) {
                            this._municipalities.splice(this._municipalities.indexOf(id), 1);
                        } else {
                            this._municipalities.push(id);
                        }
                        input.checked = !included;

                        for (const municipality of this._municipalities) {
                            this._params.append(`${name}[]`, municipality);
                        }
                    }
    
                    let queryParams = '?';
                    for (const [key, value] of this._params.entries()) {
                        queryParams += `${key}=${value}&`;
                    }
    
                    history.pushState({}, 'Produkt-søk', window.location.origin + window.location.pathname + queryParams.slice(0, -1));
    
                    this._displayMarkers();
                });
            });
        }
        
        this._toggle = document.querySelector(`[${this._btnAttr}]`);
        if (this._toggle) {
            this._toggle.addEventListener('click', () => {
                if (this._form) {
                    this._form.classList.toggle('active');
                }
                this._toggle.classList.toggle('active');
                this._toggle.innerHTML = this._toggle.innerHTML === 'Vis filter' ? 'Skjul filter' : 'Vis filter';
            });
        }
    },
    _displayMarkers() {
        for (const product of this._mapData) {
            const categoryMatch     = !this._categories.length || 
                                       this._categories.some(category => product.categories.indexOf(parseInt(category)) >= 0);
            const municipalityMatch = !this._municipalities.length || 
                                       this._municipalities.includes(product.municipality);
            const showMarker        = (municipalityMatch && categoryMatch) || 
                                      (!this._categories.length && !this._municipalities.length)
            product.marker.setVisible(showMarker)
        }
    },
    _addMarkers() {
        for (let i=0; i < this._products.length; i++ ) {
            // console.log(i);
            let product = this._products[i];
            // console.log(product);

            if (!product.lat || !product.lng) {
                continue;
            }
            
            const markerImgUrl = `/resources/img/marker_${this._mainCategories[product.category]}.svg`;
            const markerSize   = new google.maps.Size(18.4, 32.9);
            const markerIcon   = new google.maps.MarkerImage(
                markerImgUrl,
                markerSize
            );

            const marker       = new google.maps.Marker({
                position: new google.maps.LatLng(product.lat, product.lng),
                map     : this._map,
                icon    : markerIcon
            });

            this._bounds.extend(marker.position);

            const infoWindow = new google.maps.InfoWindow({
                content: this._getInfoWindowContent(product)
            });

            this._mapData.push({
                marker      : marker,
                infoWindow  : infoWindow,
                categories  : product.categories,
                municipality: product.municipality,
                pictureUrl  : product.img
            });
        }

        for (const item of this._mapData) {
            item.marker.addListener('click', () => {
                if (this._infoWindow) {
                    this._infoWindow.close();
                }
                const imgString = '<img class="map-info__image"';
                if (!item.infoWindow.content.includes(imgString + ' src=')) {
                    const splitContent = item.infoWindow.content.split(imgString);
                    if (splitContent.length === 2) {
                        const content = splitContent[0] + `${imgString} src="${item.pictureUrl}"` + splitContent[1];
                        item.infoWindow.setContent(content);
                    }
                }
                item.infoWindow.open(this._map, item.marker);
                this._infoWindow = item.infoWindow;
            });
        }
        
        this._map.fitBounds(this._bounds);
    },
    _addMunicipalitiesFilters() {
        if (this._form) {
            for (const municipality of this._mainMunicipalities) {
                this._form.innerHTML += `
                    <label for="${municipality}" data-product-search-label="kommune">
                        <input type="checkbox" 
                               class="search__filter" 
                               id="${municipality}" 
                               name="${municipality}" 
                               value="${municipality}">
                        ${municipality}
                    </label>
                `;
            }
        }
    },
    _getActionUrl() {
        let queryString = '?';
        if (this._ids) {
            const ids = JSON.parse(this._ids);
            for (const id of ids) {
                queryString += 'ids[]=' + id + '&';
            }
            queryString = queryString.slice(0, -1);
        }

        return this._action + queryString;
    },
    _getInfoWindowContent(product) {
        const iconStart = '<img class="product__info-icon" src="/resources/img/icon--';

        let content = `
            <div class="map-info" id="content">
                ${product.img ? '<img class="map-info__image">' : ''}
                <div class="map-info__content">
                    <div class="map-info__title">${product.title}</div>
                    <div class="map-info__links">
        `;
        if (product.phone) {
            content += `
                <a class="map-info__link" href="tel:${product.phone}">
                    ${iconStart}01.png" alt="">${product.phone}
                </a>
            `;
        }
        if (product.email) {
            content += `
                <a class="map-info__link" href="mailto:${product.email}">
                    ${iconStart}02.png" alt="">${product.email}
                </a>
            `;
        }
        if (product.web) {
            if (!product.web.includes('http')) {
                product.web = 'http://' + product.web;
            }
            content += `
                <a class="map-info__link" href="${product.web}">
                    ${iconStart}03.png" alt="">Nettside
                </a>
            `;
        }
        content += `
                    </div>
                    <a class="map-info__redirect" href="${product.url}">
                        Les mer${product.booking ? ' og bestill' : ''}
                    </a>
                </div>
            </div>
        `;

        return content;
    }
}